const assetPairs = {
  phoneWallet: [
    "/assets/generated/product-phone-wallet.jpg",
    "/assets/generated/product-phone-wallet-detail.jpg",
  ],
  tabletFolio: [
    "/assets/generated/product-tablet-folio.jpg",
    "/assets/generated/product-tablet-folio-detail.jpg",
  ],
  laptopStand: [
    "/assets/generated/product-laptop-stand.jpg",
    "/assets/generated/product-laptop-stand-detail.jpg",
  ],
  sleeve: [
    "/assets/generated/sleeve.jpg",
    "/assets/generated/sleeve-detail.jpg",
  ],
  deskMat: [
    "/assets/generated/desk-mat.jpg",
    "/assets/generated/desk-mat-detail.jpg",
  ],
  carrySet: [
    "/assets/generated/carry-set.jpg",
    "/assets/generated/carry-set-detail.jpg",
  ],
};

const productData = [
  {
    id: 1,
    slug: "arcfold-magnetic-wallet-stand",
    sku: "MND-PHN-001",
    name: "ArcFold Magnetic Wallet Stand",
    category: "Phones",
    type: "Wallet Stand",
    price: 49.95,
    compareAtPrice: 59.95,
    images: assetPairs.phoneWallet,
    image: assetPairs.phoneWallet[0],
    description: [
      "A slim magnetic wallet that unfolds into a stable portrait or landscape phone stand.",
      "Its layered vegan leather construction keeps three everyday cards close without adding unnecessary bulk.",
    ],
    shortDescription: "A three-card magnetic wallet with an instant folding stand.",
    attributes: {
      Compatibility: "Magnetic-ready phones and cases",
      Capacity: "Up to 3 cards",
      Positions: "Portrait and landscape",
      Profile: "6.8 mm folded",
    },
    tags: ["magnetic", "wallet", "stand", "travel"],
    colors: [
      { name: "Midnight", hex: "#24262B" },
      { name: "Mist", hex: "#D8D7D2" },
      { name: "Canyon", hex: "#A66B52" },
    ],
    size: ["Universal"],
    material: "Recycled microfiber and vegan leather",
    rating: 4.8,
    reviews: 386,
    stock: 84,
    badge: "Best Seller",
    featured: true,
  },
  {
    id: 2,
    slug: "pivot-mini-phone-tripod",
    sku: "MND-PHN-002",
    name: "Pivot Mini Phone Tripod",
    category: "Phones",
    type: "Tripod Stand",
    price: 45.95,
    compareAtPrice: null,
    images: assetPairs.phoneWallet,
    image: assetPairs.phoneWallet[0],
    description: [
      "A pocket-scale magnetic tripod designed for calls, filming and hands-free reading.",
      "The articulated base opens in one motion and holds the viewing angle without loose hinges.",
    ],
    shortDescription: "A pocketable magnetic tripod for calls and mobile filming.",
    attributes: {
      Compatibility: "Magnetic-ready phones and cases",
      Rotation: "360-degree mount",
      Height: "15 cm open",
      Weight: "98 g",
    },
    tags: ["tripod", "creator", "magnetic", "portable"],
    colors: [
      { name: "Graphite", hex: "#34363A" },
      { name: "Cloud", hex: "#ECEAE5" },
    ],
    size: ["Universal"],
    material: "Anodized aluminum and reinforced polymer",
    rating: 4.7,
    reviews: 214,
    stock: 61,
    badge: "New",
    featured: true,
  },
  {
    id: 3,
    slug: "snapview-phone-grip-stand",
    sku: "MND-PHN-003",
    name: "SnapView Phone Grip Stand",
    category: "Phones",
    type: "Grip Stand",
    price: 49.95,
    compareAtPrice: 59.95,
    images: assetPairs.phoneWallet,
    image: assetPairs.phoneWallet[0],
    description: [
      "A soft-touch grip that gives larger phones a more secure one-handed hold.",
      "Fold it flat for a clean pocket profile or open it as a low viewing stand on any table.",
    ],
    shortDescription: "A low-profile magnetic grip that doubles as a viewing stand.",
    attributes: {
      Compatibility: "Magnetic-ready phones and cases",
      Positions: "Grip, portrait and landscape",
      Profile: "5.5 mm folded",
      Weight: "42 g",
    },
    tags: ["grip", "stand", "everyday", "magnetic"],
    colors: [
      { name: "Ink", hex: "#17191D" },
      { name: "Sage", hex: "#9EA99A" },
      { name: "Clay", hex: "#BF8270" },
    ],
    size: ["Universal"],
    material: "Vegan leather and glass-fiber composite",
    rating: 4.6,
    reviews: 173,
    stock: 97,
    badge: null,
    featured: false,
  },
  {
    id: 4,
    slug: "transit-mag-card-sleeve",
    sku: "MND-PHN-004",
    name: "Transit Mag Card Sleeve",
    category: "Phones",
    type: "Card Sleeve",
    price: 45.00,
    compareAtPrice: null,
    images: assetPairs.phoneWallet,
    image: assetPairs.phoneWallet[0],
    description: [
      "A pared-back magnetic sleeve for the cards you reach for most often.",
      "A shaped thumb opening and grippy lining keep cards easy to access yet secure in motion.",
    ],
    shortDescription: "A lightweight two-card sleeve for streamlined daily carry.",
    attributes: {
      Compatibility: "Magnetic-ready phones and cases",
      Capacity: "Up to 2 cards",
      Closure: "Friction-fit lining",
      Profile: "4.9 mm empty",
    },
    tags: ["cards", "wallet", "commute", "minimal"],
    colors: [
      { name: "Navy", hex: "#253449" },
      { name: "Sand", hex: "#D4C6B2" },
      { name: "Forest", hex: "#465A4B" },
    ],
    size: ["Universal"],
    material: "Plant-based leather and recycled microfiber",
    rating: 4.5,
    reviews: 128,
    stock: 112,
    badge: null,
    featured: false,
  },
  {
    id: 5,
    slug: "halo-desk-phone-stand",
    sku: "MND-PHN-005",
    name: "Halo Desk Phone Stand",
    category: "Phones",
    type: "Desk Stand",
    price: 54.95,
    compareAtPrice: 64.95,
    images: assetPairs.phoneWallet,
    image: assetPairs.phoneWallet[0],
    description: [
      "A folding desk stand that lifts notifications and video calls into a more comfortable sightline.",
      "The magnetic face rotates smoothly while the weighted base stays planted during taps and swipes.",
    ],
    shortDescription: "A rotating magnetic phone stand with a steady folding base.",
    attributes: {
      Compatibility: "Magnetic-ready phones and cases",
      Rotation: "360-degree face",
      ViewingAngle: "15 to 70 degrees",
      Weight: "186 g",
    },
    tags: ["desk", "stand", "video calls", "folding"],
    colors: [
      { name: "Space Gray", hex: "#5C5E60" },
      { name: "Soft Silver", hex: "#C9C9C5" },
    ],
    size: ["Universal"],
    material: "Anodized aluminum and silicone",
    rating: 4.7,
    reviews: 242,
    stock: 53,
    badge: "Staff Pick",
    featured: true,
  },
  {
    id: 6,
    slug: "loopcarry-phone-lanyard-wallet",
    sku: "MND-PHN-006",
    name: "LoopCarry Phone Lanyard Wallet",
    category: "Phones",
    type: "Lanyard Wallet",
    price: 52.95,
    compareAtPrice: null,
    images: assetPairs.carrySet,
    image: assetPairs.carrySet[0],
    description: [
      "A hands-free crossbody phone tether paired with a removable two-card wallet.",
      "The adjustable cord and low-profile anchor make it easy to move from city walks to event days.",
    ],
    shortDescription: "An adjustable phone lanyard with a detachable card wallet.",
    attributes: {
      Compatibility: "Most full-coverage phone cases",
      StrapLength: "82 to 150 cm",
      Capacity: "2 cards",
      Hardware: "Quick-release aluminum clasp",
    },
    tags: ["lanyard", "hands-free", "wallet", "travel"],
    colors: [
      { name: "Black", hex: "#1B1C1E" },
      { name: "Oat", hex: "#CFC3AE" },
      { name: "Terracotta", hex: "#A85F49" },
    ],
    size: ["Universal"],
    material: "Braided recycled nylon and vegan leather",
    rating: 4.6,
    reviews: 156,
    stock: 76,
    badge: null,
    featured: false,
  },
  {
    id: 7,
    slug: "framefold-tablet-folio",
    sku: "MND-TAB-001",
    name: "FrameFold Tablet Folio",
    category: "Tablets",
    type: "Folio Stand",
    price: 69.95,
    compareAtPrice: 79.95,
    images: assetPairs.tabletFolio,
    image: assetPairs.tabletFolio[0],
    description: [
      "A protective magnetic folio that folds into four dependable work and viewing modes.",
      "The floating panel improves posture while a soft inner layer protects the tablet from daily scuffs.",
    ],
    shortDescription: "A protective tablet folio with four flexible viewing modes.",
    attributes: {
      Modes: "Typing, sketching, portrait and landscape",
      Closure: "Magnetic",
      PencilStorage: "Integrated edge channel",
      Protection: "Raised corner frame",
    },
    tags: ["folio", "tablet", "stand", "sketching"],
    colors: [
      { name: "Charcoal", hex: "#3B3D40" },
      { name: "Stone", hex: "#B8B0A5" },
      { name: "Juniper", hex: "#637267" },
    ],
    size: ["Compact 8–9 in", "Standard 10–11 in", "Large 12–13 in"],
    material: "Recycled PU, microfiber and polycarbonate",
    rating: 4.8,
    reviews: 421,
    stock: 68,
    badge: "Best Seller",
    featured: true,
  },
  {
    id: 8,
    slug: "floatboard-tablet-stand-case",
    sku: "MND-TAB-002",
    name: "FloatBoard Tablet Stand Case",
    category: "Tablets",
    type: "Elevated Case",
    price: 74.95,
    compareAtPrice: null,
    images: assetPairs.tabletFolio,
    image: assetPairs.tabletFolio[0],
    description: [
      "An elevated tablet case that brings the screen closer to eye level without a separate stand.",
      "Its folding geometry stays rigid for touch input and collapses flat when it is time to leave.",
    ],
    shortDescription: "An elevated tablet case that folds flat for transport.",
    attributes: {
      Modes: "Elevated, typing and viewing",
      Lift: "Up to 16 cm",
      PencilStorage: "Magnetic charging edge exposed",
      Closure: "Hidden magnetic tabs",
    },
    tags: ["ergonomic", "tablet", "folding", "portable"],
    colors: [
      { name: "Carbon", hex: "#292B2E" },
      { name: "Linen", hex: "#DED8CD" },
    ],
    size: ["Standard 10–11 in", "Large 12–13 in"],
    material: "Vegan leather and aluminum support sheet",
    rating: 4.7,
    reviews: 263,
    stock: 47,
    badge: "New",
    featured: true,
  },
  {
    id: 9,
    slug: "noteslate-tablet-portfolio",
    sku: "MND-TAB-003",
    name: "NoteSlate Tablet Portfolio",
    category: "Tablets",
    type: "Organizer Folio",
    price: 64.95,
    compareAtPrice: 72.95,
    images: assetPairs.tabletFolio,
    image: assetPairs.tabletFolio[0],
    description: [
      "A workday folio that keeps a tablet, stylus, notes and charging cable together.",
      "The removable magnetic panel becomes a sketching wedge while the outer portfolio stays tidy.",
    ],
    shortDescription: "A tablet folio with integrated storage for notes and cables.",
    attributes: {
      Storage: "Stylus loop, cable pocket and document sleeve",
      StandMode: "12-degree sketching wedge",
      Closure: "Elastic keeper",
      Capacity: "Tablet plus A5 notebook",
    },
    tags: ["portfolio", "organizer", "tablet", "work"],
    colors: [
      { name: "Navy", hex: "#2E3B50" },
      { name: "Mushroom", hex: "#A99D90" },
    ],
    size: ["Compact 8–9 in", "Standard 10–11 in"],
    material: "Recycled woven textile and microfiber",
    rating: 4.6,
    reviews: 147,
    stock: 59,
    badge: null,
    featured: false,
  },
  {
    id: 10,
    slug: "ridgeview-tablet-stand",
    sku: "MND-TAB-004",
    name: "RidgeView Tablet Stand",
    category: "Tablets",
    type: "Adjustable Stand",
    price: 54.95,
    compareAtPrice: null,
    images: assetPairs.tabletFolio,
    image: assetPairs.tabletFolio[0],
    description: [
      "A compact ridged stand that supports tablets at six repeatable viewing angles.",
      "Wide silicone contact points keep the screen steady while leaving charging ports clear.",
    ],
    shortDescription: "A compact tablet stand with six stable viewing angles.",
    attributes: {
      Compatibility: "Tablets from 7 to 13 inches",
      Angles: "Six positions",
      FoldedSize: "18 × 4.5 cm",
      Weight: "172 g",
    },
    tags: ["tablet", "stand", "adjustable", "travel"],
    colors: [
      { name: "Graphite", hex: "#484B4D" },
      { name: "Silver", hex: "#C6C7C5" },
    ],
    size: ["Universal"],
    material: "Machined aluminum and silicone",
    rating: 4.5,
    reviews: 119,
    stock: 88,
    badge: null,
    featured: false,
  },
  {
    id: 11,
    slug: "sketchcarry-tablet-sleeve",
    sku: "MND-TAB-005",
    name: "SketchCarry Tablet Sleeve",
    category: "Tablets",
    type: "Protective Sleeve",
    price: 46.95,
    compareAtPrice: 54.95,
    images: assetPairs.sleeve,
    image: assetPairs.sleeve[0],
    description: [
      "A padded tablet sleeve with a fold-out surface for quick sketching or note review.",
      "The asymmetrical front pocket holds a stylus and compact charger without a bulky silhouette.",
    ],
    shortDescription: "A padded tablet sleeve with stylus and charger storage.",
    attributes: {
      Protection: "5 mm recycled felt padding",
      Storage: "Two divided front pockets",
      Closure: "Concealed magnetic flap",
      Lining: "Scratch-safe microfiber",
    },
    tags: ["sleeve", "tablet", "stylus", "protection"],
    colors: [
      { name: "Ash", hex: "#777873" },
      { name: "Oat", hex: "#D0C4B2" },
      { name: "Rust", hex: "#965943" },
    ],
    size: ["Compact 8–9 in", "Standard 10–11 in", "Large 12–13 in"],
    material: "Recycled PET felt and microfiber",
    rating: 4.7,
    reviews: 201,
    stock: 73,
    badge: null,
    featured: false,
  },
  {
    id: 12,
    slug: "airlift-foldable-laptop-stand",
    sku: "MND-LAP-001",
    name: "AirLift Foldable Laptop Stand",
    category: "Laptops",
    type: "Laptop Stand",
    price: 59.95,
    compareAtPrice: 69.95,
    images: assetPairs.laptopStand,
    image: assetPairs.laptopStand[0],
    description: [
      "An origami-inspired laptop stand that raises the screen and improves airflow in seconds.",
      "It folds nearly flat, attaches magnetically to compatible sleeves and travels without loose parts.",
    ],
    shortDescription: "A flat-folding laptop stand for a healthier mobile workspace.",
    attributes: {
      Compatibility: "Laptops from 11 to 16 inches",
      Lift: "7.5 cm",
      LoadCapacity: "Up to 8 kg",
      FoldedProfile: "3.4 mm",
    },
    tags: ["laptop", "stand", "ergonomic", "portable"],
    colors: [
      { name: "Jet", hex: "#26282B" },
      { name: "Fog", hex: "#BFC0BC" },
    ],
    size: ["11–14 in", "15–16 in"],
    material: "Vegan leather, fiberglass and reusable adhesive",
    rating: 4.9,
    reviews: 512,
    stock: 91,
    badge: "Best Seller",
    featured: true,
  },
  {
    id: 13,
    slug: "risedeck-adjustable-laptop-stand",
    sku: "MND-LAP-002",
    name: "RiseDeck Adjustable Laptop Stand",
    category: "Laptops",
    type: "Adjustable Stand",
    price: 84.95,
    compareAtPrice: 99.95,
    images: assetPairs.laptopStand,
    image: assetPairs.laptopStand[0],
    description: [
      "A height-adjustable stand for turning any table into a more composed workstation.",
      "Dual hinges hold their position under typing pressure, and the open frame keeps warm devices ventilated.",
    ],
    shortDescription: "A dual-hinge aluminum stand with flexible height and angle.",
    attributes: {
      Compatibility: "Laptops from 11 to 17 inches",
      HeightRange: "6 to 21 cm",
      LoadCapacity: "Up to 10 kg",
      Base: "Anti-slip silicone feet",
    },
    tags: ["laptop", "adjustable", "desk", "aluminum"],
    colors: [
      { name: "Graphite", hex: "#55585B" },
      { name: "Natural Aluminum", hex: "#C7C8C5" },
    ],
    size: ["Universal"],
    material: "CNC-machined aluminum and silicone",
    rating: 4.8,
    reviews: 287,
    stock: 42,
    badge: "Pro",
    featured: true,
  },
  {
    id: 14,
    slug: "nomad-laptop-base",
    sku: "MND-LAP-003",
    name: "Nomad Laptop Base",
    category: "Laptops",
    type: "Portable Stand",
    price: 49.95,
    compareAtPrice: null,
    images: assetPairs.laptopStand,
    image: assetPairs.laptopStand[0],
    description: [
      "A featherweight laptop base made for hybrid work and small café tables.",
      "The slim rails lift the rear edge for ventilation and pack into the included elastic keeper.",
    ],
    shortDescription: "A featherweight rail stand for hybrid work and travel.",
    attributes: {
      Compatibility: "Laptops from 11 to 16 inches",
      Lift: "5 cm",
      Weight: "118 g",
      PackSize: "22 × 3 cm",
    },
    tags: ["laptop", "travel", "ventilation", "lightweight"],
    colors: [
      { name: "Black", hex: "#202225" },
      { name: "Slate Blue", hex: "#627082" },
    ],
    size: ["Universal"],
    material: "Aerospace-grade aluminum and silicone",
    rating: 4.5,
    reviews: 134,
    stock: 104,
    badge: null,
    featured: false,
  },
  {
    id: 15,
    slug: "aeroshell-laptop-sleeve",
    sku: "MND-LAP-004",
    name: "AeroShell Laptop Sleeve",
    category: "Laptops",
    type: "Protective Sleeve",
    price: 54.95,
    compareAtPrice: 64.95,
    images: assetPairs.sleeve,
    image: assetPairs.sleeve[0],
    description: [
      "A clean-lined sleeve with structured corner protection and a plush device compartment.",
      "Its weather-resistant shell stays slim while a hidden pocket keeps a charger or notebook close.",
    ],
    shortDescription: "A weather-resistant laptop sleeve with protected corners.",
    attributes: {
      Protection: "Reinforced corners and 6 mm foam",
      Storage: "Full-width concealed pocket",
      Closure: "Water-resistant zip",
      Lining: "Brushed recycled fleece",
    },
    tags: ["laptop", "sleeve", "protection", "commute"],
    colors: [
      { name: "Midnight", hex: "#25282D" },
      { name: "Pebble", hex: "#AAA49A" },
      { name: "Moss", hex: "#697362" },
    ],
    size: ["13 in", "14 in", "16 in"],
    material: "Recycled ballistic textile and EVA foam",
    rating: 4.8,
    reviews: 319,
    stock: 78,
    badge: "Popular",
    featured: true,
  },
  {
    id: 16,
    slug: "studio-laptop-folio",
    sku: "MND-LAP-005",
    name: "Studio Laptop Folio",
    category: "Laptops",
    type: "Work Folio",
    price: 69.95,
    compareAtPrice: null,
    images: assetPairs.sleeve,
    image: assetPairs.sleeve[0],
    description: [
      "A refined laptop folio that organizes a device, documents, pens and compact charging tools.",
      "The structured cover opens flat as a clean work surface when a shared table needs definition.",
    ],
    shortDescription: "A structured laptop folio with organized workday storage.",
    attributes: {
      Storage: "Document sleeve, pen loop and cable pocket",
      Closure: "Low-profile magnetic flap",
      WorkSurface: "Wipe-clean inner panel",
      Profile: "18 mm empty",
    },
    tags: ["folio", "laptop", "business", "organizer"],
    colors: [
      { name: "Espresso", hex: "#4A3830" },
      { name: "Ink", hex: "#2A2B2E" },
    ],
    size: ["13 in", "14 in", "16 in"],
    material: "Premium vegan leather and recycled microfiber",
    rating: 4.6,
    reviews: 166,
    stock: 51,
    badge: null,
    featured: false,
  },
  {
    id: 17,
    slug: "quietgrid-desk-mat",
    sku: "MND-WRK-001",
    name: "QuietGrid Desk Mat",
    category: "Workspace",
    type: "Desk Mat",
    price: 64.95,
    compareAtPrice: 74.95,
    images: assetPairs.deskMat,
    image: assetPairs.deskMat[0],
    description: [
      "A broad, softly cushioned desk mat that quiets keyboard noise and defines a focused work zone.",
      "The fine-grain surface tracks smoothly with a mouse and resists everyday spills and marks.",
    ],
    shortDescription: "A quiet, spill-resistant desk mat with a smooth tracking surface.",
    attributes: {
      Surface: "Low-friction mouse tracking",
      Backing: "Non-slip natural rubber",
      Thickness: "3.2 mm",
      Care: "Wipe clean",
    },
    tags: ["desk mat", "workspace", "mouse", "focus"],
    colors: [
      { name: "Charcoal", hex: "#3B3D3E" },
      { name: "Warm Gray", hex: "#99938A" },
      { name: "Forest", hex: "#4D6254" },
    ],
    size: ["Medium 68 × 32 cm", "Large 90 × 40 cm"],
    material: "Vegan leather and natural rubber",
    rating: 4.9,
    reviews: 448,
    stock: 83,
    badge: "Best Seller",
    featured: true,
  },
  {
    id: 18,
    slug: "orbit-round-desk-mat",
    sku: "MND-WRK-002",
    name: "Orbit Round Desk Mat",
    category: "Workspace",
    type: "Desk Mat",
    price: 49.95,
    compareAtPrice: null,
    images: assetPairs.deskMat,
    image: assetPairs.deskMat[0],
    description: [
      "A circular desk mat shaped for compact workstations and flexible mouse movement.",
      "Its durable stitched edge stays flat while the soft neutral palette settles naturally into shared spaces.",
    ],
    shortDescription: "A circular work surface designed for compact desks.",
    attributes: {
      Diameter: "50 cm",
      Surface: "Multi-directional mouse tracking",
      Backing: "Non-slip natural rubber",
      Edge: "Low-profile stitched finish",
    },
    tags: ["desk mat", "compact", "mouse", "workspace"],
    colors: [
      { name: "Graphite", hex: "#4A4B4B" },
      { name: "Sandstone", hex: "#B6A48D" },
    ],
    size: ["50 cm Round"],
    material: "Recycled woven textile and natural rubber",
    rating: 4.6,
    reviews: 117,
    stock: 64,
    badge: "New",
    featured: false,
  },
  {
    id: 19,
    slug: "railfold-device-riser",
    sku: "MND-WRK-003",
    name: "RailFold Device Riser",
    category: "Workspace",
    type: "Device Riser",
    price: 74.95,
    compareAtPrice: 84.95,
    images: assetPairs.laptopStand,
    image: assetPairs.laptopStand[0],
    description: [
      "A folding aluminum riser that supports a laptop or tablet beside an external display.",
      "The open rail construction creates useful space below the device while keeping cables easy to route.",
    ],
    shortDescription: "A foldable device riser that clears space beneath your screen.",
    attributes: {
      Compatibility: "Laptops and tablets up to 17 inches",
      Height: "15 cm",
      LoadCapacity: "Up to 9 kg",
      CableRoute: "Integrated rear channel",
    },
    tags: ["riser", "laptop", "tablet", "desk"],
    colors: [
      { name: "Graphite", hex: "#54575A" },
      { name: "Silver", hex: "#CACBC8" },
    ],
    size: ["Universal"],
    material: "Anodized aluminum and silicone",
    rating: 4.7,
    reviews: 193,
    stock: 39,
    badge: null,
    featured: false,
  },
  {
    id: 20,
    slug: "cablecanvas-desk-pad",
    sku: "MND-WRK-004",
    name: "CableCanvas Desk Pad",
    category: "Workspace",
    type: "Cable Desk Mat",
    price: 72.95,
    compareAtPrice: null,
    images: assetPairs.deskMat,
    image: assetPairs.deskMat[0],
    description: [
      "A generous desk pad with a discreet magnetic rail for guiding charging and keyboard cables.",
      "The reversible surface switches between a smooth work face and a tactile woven finish.",
    ],
    shortDescription: "A reversible desk pad with discreet magnetic cable control.",
    attributes: {
      Surface: "Reversible smooth and woven faces",
      CableControl: "Four repositionable magnetic clips",
      Thickness: "3.5 mm",
      Care: "Wipe clean",
    },
    tags: ["desk mat", "cable management", "reversible", "workspace"],
    colors: [
      { name: "Ink and Slate", hex: "#34383E" },
      { name: "Oat and Clay", hex: "#C3B39F" },
    ],
    size: ["Large 90 × 40 cm"],
    material: "Recycled textile, vegan leather and magnetic steel",
    rating: 4.8,
    reviews: 226,
    stock: 45,
    badge: "Innovative",
    featured: true,
  },
  {
    id: 21,
    slug: "focusdesk-setup-kit",
    sku: "MND-WRK-005",
    name: "FocusDesk Setup Kit",
    category: "Workspace",
    type: "Workspace Set",
    price: 109.95,
    compareAtPrice: 129.95,
    images: assetPairs.deskMat,
    image: assetPairs.deskMat[0],
    description: [
      "A coordinated desk mat, cable clips and catch-all tray for building a calmer workspace at once.",
      "Each piece shares the same low-key material palette and can be repositioned as the workday changes.",
    ],
    shortDescription: "A coordinated desk mat, cable clip and catch-all set.",
    attributes: {
      Includes: "Desk mat, tray and 4 cable clips",
      MatSize: "78 × 36 cm",
      Backing: "Non-slip natural rubber",
      Packaging: "Plastic-free gift box",
    },
    tags: ["bundle", "desk mat", "organization", "gift"],
    colors: [
      { name: "Graphite Set", hex: "#414345" },
      { name: "Stone Set", hex: "#AAA196" },
    ],
    size: ["One Set"],
    material: "Vegan leather, natural rubber and aluminum",
    rating: 4.8,
    reviews: 174,
    stock: 32,
    badge: "Bundle",
    featured: true,
  },
  {
    id: 22,
    slug: "metro-tech-sleeve",
    sku: "MND-CAR-001",
    name: "Metro Tech Sleeve",
    category: "Carry",
    type: "Device Sleeve",
    price: 62.95,
    compareAtPrice: 69.95,
    images: assetPairs.sleeve,
    image: assetPairs.sleeve[0],
    description: [
      "A commuter-ready device sleeve with a hidden carry handle and quick-access essentials pocket.",
      "Structured padding protects a laptop or tablet while the slim shape slides easily into a larger bag.",
    ],
    shortDescription: "A slim commuter sleeve with a concealed carry handle.",
    attributes: {
      Protection: "6 mm impact-dispersing foam",
      Storage: "Two front accessory pockets",
      Handle: "Concealed top carry loop",
      Closure: "Weather-resistant zip",
    },
    tags: ["sleeve", "commute", "laptop", "carry"],
    colors: [
      { name: "Black", hex: "#222428" },
      { name: "Moss", hex: "#63705F" },
      { name: "Taupe", hex: "#9B8F83" },
    ],
    size: ["11 in", "13 in", "14 in", "16 in"],
    material: "Recycled ballistic nylon and EVA foam",
    rating: 4.8,
    reviews: 304,
    stock: 86,
    badge: "Popular",
    featured: true,
  },
  {
    id: 23,
    slug: "orbit-accessory-organizer",
    sku: "MND-CAR-002",
    name: "Orbit Accessory Organizer",
    category: "Carry",
    type: "Tech Organizer",
    price: 48.95,
    compareAtPrice: null,
    images: assetPairs.carrySet,
    image: assetPairs.carrySet[0],
    description: [
      "A structured organizer for cables, power adapters, memory cards and small creative tools.",
      "Flexible internal loops keep different shapes secure, and the clamshell opening makes every item visible.",
    ],
    shortDescription: "A structured clamshell organizer for everyday tech essentials.",
    attributes: {
      Layout: "8 elastic loops and 3 mesh pockets",
      Opening: "Full clamshell",
      Protection: "Semi-rigid shell",
      Dimensions: "22 × 14 × 5 cm",
    },
    tags: ["organizer", "cables", "travel", "carry"],
    colors: [
      { name: "Graphite", hex: "#3B3E42" },
      { name: "Sage", hex: "#7D8A7A" },
    ],
    size: ["One Size"],
    material: "Recycled ripstop nylon and molded EVA",
    rating: 4.7,
    reviews: 231,
    stock: 69,
    badge: null,
    featured: false,
  },
  {
    id: 24,
    slug: "daytrip-device-carry-set",
    sku: "MND-CAR-003",
    name: "Daytrip Device Carry Set",
    category: "Carry",
    type: "Travel Set",
    price: 119.95,
    compareAtPrice: 139.95,
    images: assetPairs.carrySet,
    image: assetPairs.carrySet[0],
    description: [
      "A coordinated laptop sleeve and tech organizer sized for a full day away from the desk.",
      "The two pieces clip together for short carries or separate cleanly inside a backpack or tote.",
    ],
    shortDescription: "A coordinated laptop sleeve and detachable tech organizer.",
    attributes: {
      Includes: "Device sleeve, organizer and connector strap",
      Protection: "Padded device compartment",
      Carry: "Detachable shoulder strap",
      Packaging: "Plastic-free gift box",
    },
    tags: ["bundle", "travel", "sleeve", "organizer"],
    colors: [
      { name: "Midnight Set", hex: "#282B30" },
      { name: "Sand Set", hex: "#BBAE9B" },
    ],
    size: ["13 in", "14 in", "16 in"],
    material: "Recycled nylon, EVA foam and aluminum hardware",
    rating: 4.9,
    reviews: 188,
    stock: 28,
    badge: "Bundle",
    featured: true,
  },
  {
    id: 25,
    slug: "cable-nest-pouch",
    sku: "MND-CAR-004",
    name: "Cable Nest Pouch",
    category: "Carry",
    type: "Cable Pouch",
    price: 45.95,
    compareAtPrice: null,
    images: assetPairs.carrySet,
    image: assetPairs.carrySet[0],
    description: [
      "A compact pouch that keeps a charger, earbuds and short cables from disappearing inside a bag.",
      "The wide zipped mouth opens flat for quick packing, with two soft dividers that flex around contents.",
    ],
    shortDescription: "A compact lay-flat pouch for chargers, earbuds and cables.",
    attributes: {
      Layout: "2 flexible dividers and 3 loops",
      Opening: "Lay-flat dual zip",
      Dimensions: "16 × 10 × 5 cm",
      Weight: "92 g",
    },
    tags: ["cables", "pouch", "compact", "travel"],
    colors: [
      { name: "Ink", hex: "#292B2E" },
      { name: "Stone", hex: "#A69E93" },
      { name: "Marigold", hex: "#C5913A" },
    ],
    size: ["One Size"],
    material: "Recycled ripstop nylon and microfiber",
    rating: 4.6,
    reviews: 142,
    stock: 118,
    badge: null,
    featured: false,
  },
  {
    id: 26,
    slug: "fieldwork-modular-carry-set",
    sku: "MND-CAR-005",
    name: "Fieldwork Modular Carry Set",
    category: "Carry",
    type: "Modular Carry System",
    price: 149.95,
    compareAtPrice: 179.95,
    images: assetPairs.carrySet,
    image: assetPairs.carrySet[0],
    description: [
      "A modular device folio, cable pouch and strap system for moving between studios, meetings and trips.",
      "Low-profile magnetic connectors let each piece work alone or lock into one organized carry unit.",
    ],
    shortDescription: "A modular three-piece carry system for devices and accessories.",
    attributes: {
      Includes: "Device folio, cable pouch and shoulder strap",
      Connections: "Low-profile magnetic clips",
      CarryModes: "Folio, crossbody and in-bag organizer",
      Protection: "Structured 360-degree padding",
    },
    tags: ["modular", "carry", "travel", "bundle"],
    colors: [
      { name: "Graphite System", hex: "#383B3F" },
      { name: "Olive System", hex: "#626958" },
    ],
    size: ["13 in", "14 in", "16 in"],
    material: "Recycled ballistic textile, vegan leather and aluminum",
    rating: 4.9,
    reviews: 96,
    stock: 21,
    badge: "New",
    featured: true,
  },
];

const catalogProducts = productData.map((product) => {
  const imageKey = String(product.id).padStart(2, "0");
  const images = [
    `/assets/generated/catalog/product-${imageKey}.jpg`,
    `/assets/generated/catalog/product-${imageKey}-detail.jpg`,
  ];

  return {
    ...product,
    image: images[0],
    images,
  };
});

export default catalogProducts;
